<template>
<div class="text-center">
  <div class="account-invited">
    <div class="flex-v-center mb-xs-1">
      <div class="account-settings-avatar mr-1"></div>
      {{linkRequest.mainAccountEmail}}
    </div>
  </div>
  <div class="mt-1 mb-1 text-muted w-50 m-auto w-100-xs">{{ $lang.messages.account.linked_account_modal_text }}</div>
  <div>
    <button class="btn btn-transparent" @click="rejectInvite">{{ $lang.messages.reject }}</button>
    <button class="btn btn-main" @click="acceptInvite">{{ $lang.messages.accept }}</button>
  </div>
</div>
</template>

<script>
import CONST from "@/helpers/constants";
import firebase from "firebase/app";
const {LINKED_ACCOUNT_STATUSES} = CONST;
import {mapGetters, mapState} from "vuex";
import {setClaim} from "@/helpers/api";
import {db} from "@/fb/firebase";

export default {
  name: "LinkRequestDialog",
  computed: {
    ...mapGetters({
      linkRequest: 'linkRequest'
    }),
    ...mapState({
      user: state => state.user,
    }),
  },
  methods: {
    updateAccountBindStatus(status) {
      const updates = {};
      updates['/status'] = status;
      updates['/show'] = false;

      db.ref('accountBindings/' + this.linkRequest.mainAccountUid + '/linkedEmails/' + this.user.uid).update(updates);
    },
    acceptInvite() {
      this.updateAccountBindStatus(LINKED_ACCOUNT_STATUSES.APPROVED);
      setClaim({
        uid: this.user.uid,
        claim: {
          linkedUid: this.linkRequest.mainAccountUid,
        },
        refreshToken: false
      }).then(res => {
        if (res.ok) {
          this.$dtoast.pop({
            preset: 'success',
            heading: 'Account was linked',
          });
          setTimeout(firebase.auth().currentUser.getIdToken(true).then(() => window.location.reload()), 2000)
          // window.location.reload();

        }
      });
    },
    rejectInvite() {
      this.updateAccountBindStatus(LINKED_ACCOUNT_STATUSES.REJECTED)
    },
  }
}
</script>

<style scoped lang="scss">
  .account-invited {
    background: #EFF0F7;
    margin-left: -20px;
    margin-right: -20px;
    padding: 20px;
    display: flex;
    justify-content: center;
  }
</style>